module.exports = __webpack_public_path__ + "static/media/blank-background.f4a5650b.png";